import React from 'react';

const BetaBadge = () => {
  return (
    <div className="flex items-center mr-4">
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gradient-to-r from-blue-600 to-blue-400 text-white shadow-sm">
        BETA
      </span>
    </div>
  );
};

export default BetaBadge;